export default __webpack_public_path__ + "static/young-toddler9-b9cb9eeca546529f69682259747b7fad.jpg";